import React from "react";
import { Navigate } from "react-router-dom";
import { BMKProvider } from "../components/Providers/BMK-provider";

const AuthMiddleware = (props) => {
    //if (!localStorage.getItem("userInfo")|| (!localStorage.getItem("token"))) {
    //    return (
    //        localStorage.removeItem("userInfo"),
    //        localStorage.removeItem("token"),
    //        <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    //    );
    //}
    return (
        <React.Fragment>
            <BMKProvider>
                {props.children}
            </BMKProvider>
        </React.Fragment>
    );
};

export default AuthMiddleware;